import { DataSource } from '@n7-frontend/core';
import { ITableData } from '@n7-frontend/components';
export class SharesDS extends DataSource {
    protected transform(data, option): ITableData {
        if (!data || !data.companies || !data.companies.length) {
            return;
        }

        const table = [];
        data.companies.forEach( (company, index) => {
            if(index >= 1 && option.key === 'main'){
                return;
            } else if(index === 0 && option.key === 'others' ){
                return;
            }
            const nomeImpresa = (company.company_basic_info && company.company_basic_info.general_data && company.company_basic_info.general_data[0].value) || 'Informazione non disponibile';
            const percPosseduta = company.sharesOwned ? `${company.sharesOwned * 100}%` : 'Informazione non disponibile'
            table.push({
                classes: 'BODY',
                cells: [
                    {
                        classes: 'CONTENT',
                        content: nomeImpresa,
                        type: 'html'
                    },
                    {
                        classes: 'CONTENT',
                        content: percPosseduta,
                        type: 'html'
                    }
                ]
            });
        });

      

        return {
            classes: 'test-layout-table',
            body: table
        };
    }
}
